export const SAVE_OFFER_ASSET_CLIENT_STARTED = "SAVE_OFFER_ASSET_CLIENT_STARTED";
export const SAVE_OFFER_ASSET_CLIENT_SUCCEEDED = "SAVE_OFFER_ASSET_CLIENT_SUCCEEDED";
export const SAVE_OFFER_ASSET_CLIENT_FAILED = "SAVE_OFFER_ASSET_CLIENT_FAILED";

export const LOAD_OFFER_ASSET_CLIENT_SUCCEEDED = "LOAD_OFFER_ASSET_CLIENT_SUCCEEDED";
export const LOAD_OFFER_ASSET_CLIENT_BY_ID_STARTED = "LOAD_OFFER_ASSET_CLIENT_BY_ID_STARTED";
export const LOAD_OFFER_ASSET_CLIENT_BY_ID_FAILED = "LOAD_OFFER_ASSET_CLIENT_BY_ID_FAILED";
export const LOAD_OFFER_ASSET_CLIENT_BY_ID_SUCCEEDED = "LOAD_OFFER_ASSET_CLIENT_BY_ID_SUCCEEDED";

export const TOGGLE_OFFER_ASSET_CLIENT_CARD = "TOGGLE_OFFER_ASSET_CLIENT_CARD";

export const PRINTING_GDPR_STARTED = "PRINTING_GDPR_STARTED";
export const PRINTING_GDPR_SUCCEEDED = "PRINTING_GDPR_SUCCEEDED";
export const PRINTING_GDPR_FAILED = "PRINTING_GDPR_FAILED";

export const CANCEL_OFFER_ASSET_CLIENT_CHANGES = "CANCEL_OFFER_ASSET_CLIENT_CHANGES";

export const OFFER_ASSET_CLIENT_DATA_INVALIDATED = "OFFER_ASSET_CLIENT_DATA_INVALIDATED";
